import React, { FC } from 'react';

import { Button, Col, Row } from 'antd';
import { Form, Input } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { FormattedMessage } from 'react-intl';
import router from 'next/router';
import { dispatchPageViewEvent, virtualUrlInit } from 'utils';
import { useIntl } from 'react-intl';
export interface OwnProps {
  form: FormInstance;
  handleOnChange: () => (event: any) => void;
  handleOnClick: (event: any) => void;
  zipCode: string;
}

type Props = OwnProps;

export const PharmacyZipCodeInput: FC<Props> = (props): JSX.Element => {
  const { form, handleOnChange, handleOnClick, zipCode } = props;
  const { formatMessage } = useIntl();
  const CustomInputZipCode = () => {
    let inputOptions: any = {
      defaultValue: form?.getFieldValue('zipCode') || zipCode,
      formNoValidate: true,
      maxLength: 5,
      placeholder: ' ',
      required: false,
      onChange: handleOnChange(),
      value: zipCode,
    };
    return (
      <Form.Item name={'zipCode'} rules={[]} validateTrigger={'onChange'}>
        <div className="custom-text-field" key={'zipCode'}>
          <Input {...inputOptions} />
          <label id={'zipCode'}>
            <FormattedMessage id={'form.field.pharmacy.zip.code'} />
          </label>
        </div>
      </Form.Item>
    );
  };
  const handleShowPharmacies = (e) => {
    handleOnClick(e);
    dispatchPageViewEvent(router, {
      ...virtualUrlInit,
      pageType: 'pharmacy',
      detail: 'search-pharmacy',
    });
  };
  return (
    <Row className="pharmacy__selector-zipCode-search--input">
      <Col xs={16}>{CustomInputZipCode()}</Col>
      <Col xs={8} className="pharmacy__selector-zipCode-search--input__actions">
        <Button
          className="btn-primary btn-primary--black pharmacy__selector-zipCode-search--button"
          disabled={!zipCode}
          block
          onClick={handleShowPharmacies}
          htmlType="button"
        >
          <Row justify="center">
            <FormattedMessage id="form.field.pharmacy.find" />
          </Row>
        </Button>
      </Col>
    </Row>
  );
};
